import { useTranslation } from "react-i18next";

const NotificationBanner = ({ show, onClose, message, type }) => {
    const { t } = useTranslation();

    if (!show) return null;

    return (
        <div
            className={`w-full px-4 py-2 flex justify-between items-center ${
                type === "error"
                    ? "bg-red-100 text-red-800"
                    : type === "warning"
                    ? "bg-yellow-100 text-yellow-800"
                    : type === "success"
                    ? "bg-green-100 text-green-800"
                    : "bg-blue-100 text-blue-800"
            }`}
        >
            <div className="flex-1">
                {typeof message === "string" ? (
                    <span>
                        {message || t("notificationMessage") || "Welcome to our application!"}
                    </span>
                ) : (
                    message || (
                        <span>{t("notificationMessage") || "Welcome to our application!"}</span>
                    )
                )}
            </div>
            <button
                onClick={onClose}
                className="ml-2 hover:text-blue-900 flex-shrink-0"
                aria-label="Close notification"
            >
                &times;
            </button>
        </div>
    );
};

export default NotificationBanner;
